import React, { useEffect, useState } from 'react';
import { fetchVocabularyWordImage } from '../../modules/learning/api/vocabulary';
import { categoryEmoji } from './categoryEmoji';

type Props = {
  flashcardId?: string | null;
  vocabularyEntryId?: string | null;
  imageUrl?: string | null;
  hasImage?: boolean;
  category?: string | null;
  className?: string;
  emojiClassName?: string;
  alt?: string;
};

export function VocabularyWordImage({
  flashcardId,
  vocabularyEntryId,
  imageUrl,
  hasImage,
  category,
  className = 'h-16 w-16 object-contain',
  emojiClassName = 'text-4xl leading-none',
  alt = '',
}: Props) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;
    setFailed(false);
    setSrc(null);

    const load = async () => {
      if (flashcardId || vocabularyEntryId) {
        try {
          const blob = await fetchVocabularyWordImage({
            flashcardId: flashcardId ?? undefined,
            vocabularyEntryId: vocabularyEntryId ?? undefined,
          });
          if (cancelled) return;
          objectUrl = URL.createObjectURL(blob);
          setSrc(objectUrl);
          return;
        } catch {
          // fall through to signed URL
        }
      }
      if (imageUrl && hasImage !== false) {
        setSrc(imageUrl);
      }
    };

    void load();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [flashcardId, vocabularyEntryId, imageUrl, hasImage]);

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span className={emojiClassName} aria-hidden>
      {categoryEmoji(category || 'plant')}
    </span>
  );
}
